import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import api from '../lib/api';

export const useClientOverview = () => {
    const { id } = useParams();

    const {
        data: overview,
        isLoading,
        error,
        refetch,
    } = useQuery({
        queryKey: ['clientOverview', id],
        queryFn: () => api.get(`/company/clients/${id}/overview`).then(res => res.data.data),
        staleTime: 1000 * 60 * 5,
        enabled: !!id,
    });

    return {
        overview,
        isLoading,
        error,
        refetch,
    };
};